<div class="main-content" style="min-height: calc(100vh - 120px); display: flex; flex-direction: column;">
  <div class="header bg-gradient-danger py-7 py-lg-8 pt-lg-9">
    <div class="separator separator-bottom separator-skew zindex-100">
      <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none"
        version="1.1" xmlns="http://www.w3.org/2000/svg">
        <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
      </svg>
    </div>
  </div>

  <div class="flex-grow-1 d-flex align-items-center container-fluid mt--8 pb-5 px-3 px-md-4" style="max-width: 1400px;">
    <div class="row justify-content-center w-100">
      <div class="col-12">

        <div class="card border-0 mb-0 bg-white" style="
          box-shadow: 0 8px 40px rgba(0,0,0,0.10);
          border-radius: 16px;
          overflow: hidden;
        ">
          <div class="row no-gutters" style="position: relative; min-height: 480px;">

            <!-- ELLIPSE -->
            <img
              src="assets/img/icons/common/not-found-elipse.png"
              alt=""
              aria-hidden="true"
              class="d-none d-lg-block"
              style="
                position: absolute;
                top: 0;
                right: 0;
                height: 100%;
                width: auto;
                pointer-events: none;
                user-select: none;
                z-index: 5;
              "
            />

            <!-- LEFT: Illustration -->
            <div class="d-none d-lg-flex col-lg-6 align-items-center justify-content-center bg-white" style="
              min-height: 480px;
              position: relative;
              z-index: 1;
            ">
              <img
                src="assets/img/brand/not-found.png"
                alt="404 illustration"
                class="img-fluid p-4"
                style="max-width: 380px;"
              />
            </div>

            <!-- RIGHT: Content -->
            <div class="col-12 col-lg-6 bg-transparent d-flex align-items-center justify-content-center" style="
              position: relative;
              min-height: 480px;
              z-index: 10;
            ">

              <!-- Mobile illustration -->
              <div class="d-flex d-lg-none justify-content-center w-100" style="
                position: absolute;
                top: 24px;
                left: 0;
              ">
                <img
                  src="assets/img/brand/not-found.png"
                  alt="404 illustration"
                  class="img-fluid"
                  style="max-width: 220px;"
                />
              </div>

              <!-- Card body box -->
              <div class="not-found-box" style="
                position: relative;
                z-index: 20;
                border: 2.5px dashed #111111;
                border-radius: 12px;
                padding: 28px 24px;
                width: 100%;
                max-width: 440px;
                background-color: transparent;
              ">
                <h2 class="font-weight-bold mb-3" style="font-size: 1.5rem; color: #000000;">
                  Oops! We can't find that page.
                </h2>

                <p class="mb-4" style="font-size: 0.92rem; line-height: 1.7; color: #000000;">
                  The page you're looking for might have been removed,
                  renamed, or never existed in the first place.
                  Let's get you back on track.
                </p>

                <div class="d-flex justify-content-center">
                  <a routerLink="/home" class="btn" style="
                    background-color: #0E222E;
                    color: #ffffff;
                    padding: 10px 32px;
                    border-radius: 8px;
                    font-weight: 600;
                    letter-spacing: 0.4px;
                  ">
                    Return to Homepage
                  </a>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

</div>